import { render, staticRenderFns } from "./AppFaq.vue?vue&type=template&id=269826f3&scoped=true&"
import script from "./AppFaq.vue?vue&type=script&lang=js&"
export * from "./AppFaq.vue?vue&type=script&lang=js&"
import style0 from "./AppFaq.vue?vue&type=style&index=0&id=269826f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269826f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269826f3')) {
      api.createRecord('269826f3', component.options)
    } else {
      api.reload('269826f3', component.options)
    }
    module.hot.accept("./AppFaq.vue?vue&type=template&id=269826f3&scoped=true&", function () {
      api.rerender('269826f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AppFaq.vue"
export default component.exports